module.exports = __webpack_public_path__ + "bin/eaaaf2f6f63d2630118ae7885fd26145.png";